import { useState } from "react";
import { ShieldAlert, ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";
import { useSecurityStatus } from "../../hooks/useSecurity";
import { SecurityDialog } from "./SecurityDialog";

// El escudo del encabezado: verde si los 2 pasos están activos, ámbar si no. Abre «Seguridad».
export function SecurityButton() {
  const [open, setOpen] = useState(false);
  const { data: status } = useSecurityStatus(true);
  const safe = !!status?.totp_enabled;
  return (
    <>
      <Button data-testid="security-button" variant="ghost" size="icon" title={safe ? "Seguridad" : "Seguridad: activa los 2 pasos"} aria-label="Seguridad" onClick={() => setOpen(true)}>
        {safe ? <ShieldCheck className="h-4 w-4 text-emerald-500" /> : <ShieldAlert className="h-4 w-4 text-amber-500" />}
      </Button>
      <SecurityDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
